{
  "accordion": {
    "blurb": "Un conjunto de encabezados interactivos apilados verticalmente que revelan cada uno una sección de contenido.",
    "contentOne": "Sí. Se adhiere al patrón de diseño WAI-ARIA.",
    "contentThree": "Sí. Está animado por defecto, pero puedes deshabilitarlo si prefieres.",
    "contentTwo": "Sí. Viene con un estilo predeterminado que coincide con la estética de los otros componentes.",
    "name": "Acordeón",
    "triggerOne": "¿Es accesible?",
    "triggerThree": "¿Está animado?",
    "triggerTwo": "¿Está estilizado?"
  },
  "alert": {
    "actionCta": "Deshacer",
    "actionTitle": "Los correos seleccionados han sido marcados como spam.",
    "blurb": "Una notificación para capturar la atención del usuario.",
    "errorDescription": "Por favor verifica tu información de facturación e inténtalo de nuevo.<ul><li>Revisa los detalles de tu tarjeta</li><li>Verifica la dirección de facturación</li></ul>",
    "errorDescriptionNative": "Por favor verifica tu información de facturación e inténtalo de nuevo.",
    "errorTitle": "No se pudo procesar tu pago.",
    "extendedDescription": "Esta es una descripción igualmente larga que contiene información detallada sobre la alerta. Muestra cómo el componente puede acomodar contenido extenso mientras preserva el espaciado apropiado, la alineación y la legibilidad en diferentes tamaños de pantalla y anchos de ventana. Esto ayuda a asegurar que la experiencia del usuario permanezca consistente independientemente de la longitud del contenido.",
    "extendedTitle": "Este es un título de alerta extremadamente largo que se extiende por múltiples líneas para demostrar cómo el componente maneja encabezados muy largos mientras mantiene la legibilidad y el comportamiento apropiado de ajuste de texto",
    "name": "Alerta",
    "noDescTitle": "Esta Alerta no tiene descripción.",
    "successDescription": "Esta es una alerta con ícono, título y descripción.",
    "successTitle": "¡Éxito! Tus cambios han sido guardados"
  },
  "alertDialog": {
    "blurb": "Un diálogo modal que interrumpe al usuario con contenido importante y espera una respuesta.",
    "description": "Esta acción no se puede deshacer. Esto eliminará permanentemente tu cuenta y removerá tus datos de nuestros servidores.",
    "name": "Diálogo de Alerta",
    "title": "¿Estás absolutamente seguro?",
    "trigger": "Mostrar diálogo"
  },
  "avatar": {
    "blurb": "Un componente de imagen que presenta una representación alternativa para mostrar al usuario.",
    "name": "Avatar"
  },
  "badge": {
    "blurb": "Un componente pequeño de conteo o etiquetado que puede usarse para resaltar elementos nuevos o no leídos.",
    "default": "Predeterminado",
    "destructive": "Destructivo",
    "name": "Insignia",
    "outline": "Contorno",
    "secondary": "Secundario"
  },
  "blocks": {
    "title": "Bloques"
  },
  "breadcrumbs": {
    "title": "Migas de Pan"
  },
  "button": {
    "blurb": "Un elemento clicable que realiza una acción cuando es presionado.",
    "default": "Predeterminado",
    "destructive": "Destructivo",
    "disabled": "Deshabilitado",
    "ghost": "Fantasma",
    "large": "Grande",
    "learnMore": "Aprende más",
    "link": "Enlace",
    "loading": "Cargando...",
    "name": "Botón",
    "outline": "Contorno",
    "secondary": "Secundario",
    "send": "Enviar",
    "small": "Pequeño"
  },
  "card": {
    "image": {
      "description": "Esta es una tarjeta con una imagen.",
      "title": "Tarjeta de imagen"
    },
    "login": {
      "cta": "Iniciar sesión",
      "ctaGoogle": "Iniciar sesión con Google",
      "description": "Ingresa tu correo electrónico abajo para iniciar sesión en tu cuenta",
      "emailLabel": "Correo electrónico",
      "emailPlaceholder": "yo@ejemplo.com",
      "forgotPassword": "¿Olvidaste tu contraseña?",
      "noAccount": "¿No tienes una cuenta? <a>Regístrate</a>",
      "passwordLabel": "Contraseña",
      "title": "Inicia sesión en tu cuenta"
    },
    "meetingNotes": {
      "description": "Transcripción de la reunión con el cliente.",
      "title": "Notas de reunión"
    },
    "meta": {
      "content": "Contenido",
      "contentOnly": "Solo contenido",
      "footer": "Pie de página",
      "footerOnly": "Solo pie de página",
      "headerAndContentDescription": "Esta es una tarjeta con encabezado y contenido.",
      "headerAndContentTitle": "Encabezado y contenido",
      "headerAndFooterDescription": "Esta es una tarjeta con encabezado y pie de página.",
      "headerAndFooterTitle": "Encabezado y pie de página",
      "headerContentAndFooterDescription": "Esta es una tarjeta con encabezado, contenido y pie de página.",
      "headerContentAndFooterTitle": "Encabezado, contenido y pie de página",
      "headerOnlyDescription": "Esta es una tarjeta con encabezado y descripción.",
      "headerOnlyTitle": "Solo encabezado"
    }
  },
  "checkbox": {
    "multi": {
      "description": "Selecciona cómo te gustaría recibir notificaciones",
      "email": "Correo electrónico",
      "label": "Preferencias de notificación",
      "push": "Notificaciones push",
      "sms": "SMS"
    },
    "privacy": "Acepto la política de privacidad",
    "terms": "Acepto los términos y condiciones"
  },
  "collapsible": {
    "blurb": "Un elemento dinámico que facilita la expansión o colapso de un panel.",
    "name": "Colapsible"
  },
  "components": {
    "errorMessage": "Algo salió mal en el componente: {{name}}",
    "name": "Componentes",
    "title": "Componentes"
  },
  "datePicker": {
    "placeholder": "Selecciona una fecha",
    "required": "Debe seleccionar una fecha"
  },
  "dialog": {
    "form": {
      "description": "Haz cambios a tu perfil aquí. Haz clic en guardar cuando termines.",
      "nameLabel": "Nombre",
      "title": "Edita tu perfil",
      "trigger": "Editar perfil",
      "usernameLabel": "Nombre de usuario"
    },
    "scrollableContent": {
      "description": "Este es un diálogo con contenido desplazable.",
      "title": "Contenido desplazable",
      "trigger": "Contenido desplazable"
    },
    "stickyFooter": {
      "description": "Este es un diálogo con contenido desplazable y pie de página pegajoso.",
      "title": "Pie de página pegajoso",
      "trigger": "Pie de página pegajoso"
    }
  },
  "dropdownMenu": {
    "account": "Cuenta",
    "billing": "Facturación",
    "blurb": "Muestra un menú al usuario — como un conjunto de acciones o funciones — activado por un botón.",
    "name": "Menú Desplegable",
    "notifications": "Notificaciones",
    "upgrade": "Actualizar a Pro"
  },
  "form": {
    "bioDescription": "Puedes @mencionar a otros usuarios y organizaciones.",
    "bioLabel": "Biografía",
    "bioPlaceholder": "Cuéntanos sobre ti",
    "blurb": "Una demostración de todos los componentes de entrada incluidos en esta plantilla.",
    "emailDescription": "Esta es la dirección de correo electrónico que se mostrará en tu perfil.",
    "emailLabel": "Mostrar correo electrónico",
    "emailPlaceholder": "Selecciona un correo electrónico",
    "name": "Formulario",
    "nextSubscriptionDateLabel": "Próxima fecha de suscripción",
    "nextSubscriptionDatePlaceholder": "Selecciona una fecha",
    "nextSubscriptionTimeLabel": "Próxima hora de suscripción",
    "nextSubscriptionTimePlaceholder": "Selecciona una hora",
    "notificationsChannelLabel": "Preferencias de canal",
    "notificationsSubtitle": "Notificaciones",
    "notificationsTypeLabel": "Notificarme sobre...",
    "otpBlurb": "Ingresa el código de 6 dígitos enviado a <medium>{{phoneNumber}}</medium>",
    "otpDescription": "Una demostración de un formulario con entrada OTP para autenticación.",
    "otpLabel": "Verificación OTP",
    "otpTitle": "Formulario OTP",
    "subscriptionSubtitle": "Suscripción",
    "title": "Formulario",
    "usernameDescription": "Este es tu nombre de usuario público.",
    "usernameLabel": "Nombre de usuario",
    "usernamePlaceholder": "Ingresa tu nombre de usuario",
    "validation": {
      "bioTooLong": "La biografía debe tener máximo 140 caracteres",
      "bioTooShort": "La biografía debe tener al menos 10 caracteres",
      "usernameTooShort": "El nombre de usuario debe tener al menos 3 caracteres"
    }
  },
  "hoverCard": {
    "description": "Esta es una tarjeta flotante. Puede contener cualquier contenido que desees, como texto, imágenes, o incluso otros componentes.\n\nLas tarjetas flotantes son excelentes para proporcionar información adicional sin saturar la interfaz. Pueden usarse para mostrar tooltips, detalles adicionales, o incluso acciones relacionadas con el elemento sobre el que se pasa el cursor.",
    "title": "Tarjeta Flotante",
    "trigger": "Pasa el cursor sobre mí"
  },
  "input": {
    "default": "Predeterminado",
    "disabled": "Deshabilitado",
    "error": "Con error",
    "file": "Archivo",
    "number": "Número",
    "password": "Contraseña",
    "phoneNumber": "Número de teléfono",
    "required": "Requerido",
    "required_label": "Debes completar este campo",
    "search": "Buscar"
  },
  "label": {
    "disabled": "Deshabilitado",
    "username": "Nombre de usuario"
  },
  "menubar": {
    "edit": "Editar",
    "editMenu": {
      "copy": "Copiar",
      "cut": "Cortar",
      "find": "Buscar",
      "findOptions": {
        "find": "Buscar...",
        "findNext": "Buscar Siguiente",
        "findPrevious": "Buscar Anterior",
        "searchWeb": "Buscar en la web"
      },
      "paste": "Pegar",
      "redo": "Rehacer",
      "undo": "Deshacer"
    },
    "file": "Archivo",
    "fileMenu": {
      "newIncognitoWindow": "Nueva Ventana de Incógnito",
      "newTab": "Nueva Pestaña",
      "newWindow": "Nueva Ventana",
      "print": "Imprimir...",
      "share": "Compartir",
      "shareOptions": {
        "emailLink": "Enviar enlace por correo",
        "messages": "Mensajes",
        "notes": "Notas"
      }
    },
    "profiles": "Perfiles",
    "profilesMenu": {
      "addProfile": "Agregar Perfil...",
      "andy": "Andy",
      "benoit": "Benoit",
      "edit": "Editar...",
      "luis": "Luis"
    },
    "view": "Ver",
    "viewMenu": {
      "alwaysShowBookmarksBar": "Mostrar Siempre la Barra de Marcadores",
      "alwaysShowFullUrls": "Mostrar Siempre URLs Completas",
      "forceReload": "Forzar Recarga",
      "hideSidebar": "Ocultar Barra Lateral",
      "reload": "Recargar",
      "toggleFullscreen": "Alternar Pantalla Completa"
    }
  },
  "navigationMenu": {
    "backlog": "Pendientes",
    "blocks": "Bloques",
    "blog": "Blog",
    "blogDescription": "Lee nuestras últimas publicaciones del blog.",
    "components": "Componentes",
    "componentsDescription": "Explora todos los componentes en la librería.",
    "documentation": "Documentación",
    "documentationDescription": "Aprende cómo usar la librería.",
    "done": "Hecho",
    "list": "Lista",
    "simpleList": "Lista Simple",
    "toDo": "Por Hacer",
    "withIcons": "Con Íconos"
  },
  "orgName": "Desarrollo Mindsea",
  "otpInput": {
    "withCharacters": "Con caracteres",
    "withDigits": "Con dígitos",
    "withDigitsAndCharacters": "Con dígitos y caracteres"
  },
  "progress": {
    "blurb": "Una representación visual del progreso de una tarea o proceso.",
    "name": "Progreso"
  },
  "radioGroup": {
    "cardLabel": "Tarjeta",
    "comfortable": "Cómodo",
    "compact": "Compacto",
    "default": "Predeterminado",
    "disabledLabel": "Espaciado (Deshabilitado)",
    "planDescription": "Selecciona un plan que funcione mejor para tu equipo.",
    "planLabel": "Plan",
    "proDescription": "Funciones avanzadas para equipos más grandes que buscan escalar su negocio.",
    "proLabel": "Plan Pro",
    "spacingLabel": "Espaciado",
    "starterDescription": "Perfecto para equipos pequeños que comienzan con nuestra plataforma.",
    "starterLabel": "Plan Inicial"
  },
  "scrollArea": {
    "photoBy": "Foto por <bold>{{artist}}</bold>",
    "tags": "Etiquetas"
  },
  "select": {
    "asyncMultiSelectLabel": "Selección múltiple (asíncrona)",
    "asyncMultiSelectPlaceholder": "Selecciona tus Pokémons favoritos",
    "asyncSingleSelectLabel": "Selección única (asíncrona)",
    "asyncSingleSelectPlaceholder": "Selecciona tu Pokémon favorito",
    "disabled": "Deshabilitado",
    "multiSelectLabel": "Selección múltiple",
    "multiSelectPlaceholder": "Selecciona colores",
    "singleSelectLabel": "Selección única",
    "singleSelectPlaceholder": "Selecciona un color"
  },
  "separator": {
    "blog": "Blog",
    "blurb": "Crea una distinción visual o semántica entre contenido.",
    "description": "Separadores verticales y horizontales.",
    "docs": "Documentos",
    "name": "Separador",
    "source": "Fuente",
    "title": "Separadores"
  },
  "sheet": {
    "editProfile": {
      "description": "Haz cambios a tu perfil aquí. Haz clic en guardar cuando termines.",
      "nameLabel": "Nombre",
      "title": "Editar perfil",
      "usernameLabel": "Nombre de usuario"
    }
  },
  "skeleton": {
    "blurb": "Un marcador de posición que representa la estructura de un componente mientras se está cargando.",
    "name": "Esqueleto"
  },
  "switch": {
    "airplaneMode": "Modo avión",
    "bluetooth": "Bluetooth",
    "disabled": "Interruptor deshabilitado",
    "required": "Interruptor requerido"
  },
  "table": {
    "caption": "Una lista de tus facturas recientes",
    "header": {
      "amount": "Cantidad",
      "invoice": "Factura",
      "method": "Método",
      "status": "Estado"
    },
    "total": "Total"
  },
  "tabs": {
    "account": "Cuenta",
    "accountDescription": "Haz cambios a tu cuenta aquí. Haz clic en guardar cuando termines.",
    "blurb": "Un conjunto de secciones de contenido en capas — conocidas como paneles de pestañas — que se muestran una a la vez.",
    "code": "Código",
    "currentPasswordLabel": "Contraseña actual",
    "disabled": "Deshabilitado",
    "home": "Inicio",
    "name": "Pestañas",
    "nameLabel": "Nombre",
    "newPasswordLabel": "Nueva contraseña",
    "password": "Contraseña",
    "passwordDescription": "Cambia tu contraseña aquí. Después de guardar, cerrarás sesión.",
    "preview": "Vista previa",
    "savePasswordCta": "Guardar contraseña",
    "settings": "Configuraciones",
    "usernameLabel": "Nombre de usuario"
  },
  "text": {
    "blurb": "Tipografía del sistema de diseño",
    "copy": "El rápido zorro marrón salta sobre el perro perezoso.",
    "name": "Texto"
  },
  "textarea": {
    "default": "Predeterminado",
    "disabled": "Deshabilitado",
    "error": "Con error"
  },
  "theme": {
    "blurb": "A continuación hay una lista de todos los colores en el tema actual.\nAlterna entre modo claro y oscuro para ver cómo se adaptan los colores.",
    "name": "Tema",
    "paletteTitle": "Paleta de Colores",
    "title": "Tema",
    "toggle": "Alternar Tema"
  },
  "title": "Sandbox de Componentes",
  "toast": {
    "action": "Deshacer",
    "blurb": "Una notificación no modal que aparece temporalmente para proporcionar retroalimentación al usuario.",
    "default": "El evento ha sido creado",
    "description": "Lunes, 3 de enero a las 6:00 pm",
    "error": "No se pudo crear el evento",
    "info": "Estate en el área 10 minutos antes del horario del evento",
    "name": "Toast",
    "warning": "La hora de inicio del evento no puede ser anterior a las 8 am"
  },
  "tooltip": {
    "blurb": "Un pequeño popup que proporciona información adicional sobre un elemento cuando se pasa el cursor o se enfoca.",
    "content": "Agregar a biblioteca",
    "default": "Hover",
    "extendedContent": "Para aprender más sobre cómo funciona esto, revisa la documentación.\n\nSi tienes alguna pregunta, por favor contáctanos.",
    "info": "Info",
    "name": "Tooltip"
  }
}
